<div class="rbac-tab" [attr.data-subcategory]="'Config Settings'">
    <p-tabMenu [model]="items" [activeItem]="activeItem"></p-tabMenu>
  </div>
  <router-outlet></router-outlet>